export default __webpack_public_path__ + "static/media/nir.5be60648.png";